import './Spinner.scss'

interface SpinnerProps {
  isOpen?: boolean
  size?: 'small' | 'medium' | 'large'
  message?: string
  overlay?: boolean
}

function Spinner({
  isOpen = true,
  size = 'medium',
  message,
  overlay = false,
}: SpinnerProps) {
  if (!isOpen) return null

  const spinnerContent = (
    <div className={`spinner-container ${overlay ? 'spinner-overlay' : ''}`}>
      <div className={`spinner spinner-${size}`}>
        <div className="spinner-circle"></div>
      </div>
      {message && <p className="spinner-message">{message}</p>}
    </div>
  )

  return spinnerContent
}

export default Spinner
